import {Injectable} from '@angular/core';
import {StorageService} from "@services/storage/storage.service";
import {from} from "rxjs";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class UserService {

  getPassword() {
    return from(this.storage.getItem('password')).pipe(map(password => password?.toString() ?? ''));
    //return from(this.storage.getItem('userData')).pipe(map((data: any) => data?.password?.toString() ?? ''));
  }

  set password(value: string) {
    this.storage.setItem('password', value).then();
  }

  getUsername() {
    return from(this.storage.getItem('username')).pipe(map(username => username?.toString() ?? ''));
    //return from(this.storage.getItem('userData')).pipe(map(data => data?.username?.toString() ?? ''));
  }

  set username(value: any) {
    this.storage.setItem('username', value).then();
  }

  constructor(public storage: StorageService) {
  }

  getUserData() {
    return from(this.storage.getItem('userData')).pipe(map((data: any) => data ?? {}));
  }

  logout() {
    this.username = '';
    this.password = '';
  }
}
